import { LabelProps } from '@/components/shared/Label/Label.types';
import { cx } from '@onbeam/business-styled-system/css';
import { flex } from '@onbeam/business-styled-system/patterns';

export const Label = ({ className, icon, children }: LabelProps) => {
  return (
    <div
      className={cx(
        flex({
          gap: '1.5',
          align: 'center',
          px: '3.5',
          py: '1.5',
          bg: 'mono.primaryFg',
          border: '1px solid',
          borderColor: 'mono.primaryBg/8',
          rounded: 'full',
          textStyle: 'body-lg',
        }),
        className,
      )}
    >
      {icon}
      {children}
    </div>
  );
};
